import stringComparison from 'string-comparison';

// src/helpers/menu/actionsHelpers.ts
var SIMILARITY_THRESHOLD = 0.8;
var getSimilarNameItemIds = (items, itemName) => {
  const similarItemIds = [];
  Object.values(items).forEach((item) => {
    const similarity = stringComparison.cosine.similarity(itemName, item.name);
    if (similarity >= SIMILARITY_THRESHOLD) {
      similarItemIds.push(item.itemId);
    }
  });
  return similarItemIds;
};

export { getSimilarNameItemIds };
